import React from "react";
import Toast from "./Toast";

// Show only the most recent notification as a centered modal.
// Older queued notifications will surface after the current one dismisses.
const ToastContainer = ({ toasts, onDismiss }) => {
  if (!toasts || toasts.length === 0) return null;

  const current = toasts[toasts.length - 1];

  return (
    <>
      <style>{`
        @keyframes shrink {
          from { width: 100%; }
          to   { width: 0%;   }
        }
      `}</style>
      <Toast key={current.id} toast={current} onDismiss={onDismiss} />
    </>
  );
};

export default ToastContainer;
